import { ReferenceInput, required, SelectInput } from "react-admin";
import { useField } from "react-final-form";

const WaveInput = () => {
  const routeInput = useField("routeId");
  const parentsInput = useField("parentIds");
  const driversInput = useField("driverIds");

  const reset = () => {
    routeInput.input.onChange("");
    parentsInput.input.onChange([]);
    driversInput.input.onChange([]);
  };

  return (
    <ReferenceInput
      label="Select Wave"
      source="busScheduleId"
      reference="busSchedules"
      filter={{ HasRoutePlan: true }}
      onChange={reset}
      perPage={9999}
      validate={required()}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default WaveInput;
